export default {
  title: `Client's data`
}
